import { usmle2InternalModule } from "./internalMedicine";
import { usmle2SurgeryModule } from "./surgery";
import { usmle2PedsModule } from "./pediatrics";
import { usmle2ObgynModule } from "./obgyn";
import { usmle2PsychModule } from "./psychiatry";
import { usmle2EmergencyModule } from "./emergency";
import { usmle2EthicsModule } from "./ethics";
import { usmle2BiostatsModule } from "./biostats";

export const usmle2Modules = [
  usmle2InternalModule,
  usmle2SurgeryModule,
  usmle2PedsModule,
  usmle2ObgynModule,
  usmle2PsychModule,
  usmle2EmergencyModule,
  usmle2EthicsModule,
  usmle2BiostatsModule,
];
